export function pluralizeWord(
  word: string,
  count: number,
  order: 'after' | 'before' | 'hideNumber' = 'after',
  pluralWord: string | undefined = undefined
): string {
  const finalPluralWord = pluralWord ?? `${word}s`;
  const pluralizedWord = count === 1 ? word : finalPluralWord;

  if (order === 'hideNumber') {
    return pluralizedWord;
  }

  return order === 'after' ? `${count} ${pluralizedWord}` : `${pluralizedWord} ${count}`;
}
